export const CATEGORIES = [
  "Coatings",
  "Marinades",
  "Sauzen",
  "Kruidenmixen",
  "Pepermixen",
  "Pekika",
  "Deals",
  "Gereedschap",
];

export const WAREHOUSES = [
  { id: "kipkruiden", name: "Kipkruiden", short: "Kipkruiden",
    location: "Hoogeveenenweg 73", description: "Hoofdmagazijn en productielocatie" },
  { id: "vandenbrink", name: "Van den Brink", short: "Van den Brink",
    location: "Zeewolde", description: "Externe opslaglocatie" },
];

export const VDB_EDIT_ROLES = ["hubert", "rodilene", "admin"];

export const WAREHOUSE_LABEL = {
  kipkruiden: "Kipkruiden",
  vandenbrink: "Van den Brink",
};

export const PO_STATUSES = [
  "draft", "approved", "ordered", "production_planned", "in_production",
  "ready", "shipped", "in_transit", "received", "delayed", "closed",
];

export const PO_STATUS_LABEL = {
  draft: "Concept",
  approved: "Goedgekeurd",
  ordered: "Besteld",
  production_planned: "Productie gepland",
  in_production: "In productie",
  ready: "Gereed",
  shipped: "Verzonden",
  in_transit: "Onderweg",
  received: "Ontvangen",
  delayed: "Vertraagd",
  closed: "Afgesloten",
};

// Groen = gezond, Oranje = attentie, Rood = urgent, Blauw = besteld/onderweg
export const PO_STATUS_TONE = {
  draft: "muted",
  approved: "in-transit",
  ordered: "in-transit",
  production_planned: "in-transit",
  in_production: "in-transit",
  ready: "in-transit",
  shipped: "in-transit",
  in_transit: "in-transit",
  received: "healthy",
  closed: "healthy",
  delayed: "critical",
};

export const STOCK_STATUS_LABEL = {
  op_voorraad: "Op voorraad",
  laag: "Lage voorraad",
  kritiek: "Kritiek",
  niet_op_voorraad: "Niet op voorraad",
};

export const STOCK_STATUS_TONE = {
  op_voorraad: "healthy",
  laag: "low",
  kritiek: "critical",
  niet_op_voorraad: "critical",
};

export const ADVICE_LABEL = {
  geen_actie: "Geen actie nodig",
  binnenkort: "Binnenkort bestellen",
  nu_bestellen: "Nu bestellen",
  in_bestelling: "Bestelling loopt al",
  vertraagd: "Levering vertraagd",
};

export const ADVICE_TONE = {
  geen_actie: "healthy",
  binnenkort: "low",
  nu_bestellen: "critical",
  in_bestelling: "in-transit",
  vertraagd: "critical",
};

export const ROLES = [
  { id: "hubert", name: "Hubert · Management", short: "Hubert",
    description: "Voorraad, inkoopadvies, bestellingen goedkeuren, rapportages." },
  { id: "rodilene", name: "Rodilene · Administratie & Inkoop", short: "Rodilene",
    description: "Voorraad, inkoopadvies, bestellingen aanmaken en beheren, leveranciers." },
  { id: "magazijn", name: "Magazijnmedewerker", short: "Magazijn",
    description: "Voorraad, leveringen ontvangen, batches en THT invullen." },
  { id: "admin", name: "Administrator", short: "Admin",
    description: "Gebruikers, Exact-koppeling, synchronisaties, technische instellingen." },
];

export const COMPANY = {
  name: "Kipkruiden.nl",
  tagline: "Voorraad · Inkoop · Magazijn",
};
